export enum ActivityFilter {
  All = 'all',
  Attention = 'attention',
  Jobs = 'jobs',
}
